import {
  GET_MANUFACTURER_EMPANELMENT_DETAIL,
  GET_BOOKED_TESTING_SLOT,
  GET_EMPANELMENT_DEVICE,
  GET_EMPANELMENT_TIME_SLOTS,
  CHECK_EMPANELMENT_SLOT_TYPE,
  MANUFACTURER_EMPANELMENT_SLOT,
  GET_EMPANELMENT_DOCUMENTS,
  GET_EMPANELMENT_DOCUMENT_TYPES,
} from "../actions/types";

const initialState = {
  empDetail: [],
  slotDetail: [],
  deviceDetail: [],
  timeSlots: [],
  slotType: [],
  empSlots: [],
  docDetails: [],
  docTypeDetails: [],
};

const manufacturerEmpanelmentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_MANUFACTURER_EMPANELMENT_DETAIL:
      return {
        ...state,
        empDetail: payload,
      };
    case GET_BOOKED_TESTING_SLOT:
      return {
        ...state,
        slotDetail: payload,
      };
    case GET_EMPANELMENT_DEVICE:
      return {
        ...state,
        deviceDetail: payload,
      };
    case GET_EMPANELMENT_TIME_SLOTS:
      return {
        ...state,
        timeSlots: payload,
      };
    case CHECK_EMPANELMENT_SLOT_TYPE:
      return {
        ...state,
        slotType: payload,
      };
    case MANUFACTURER_EMPANELMENT_SLOT:
      return {
        ...state,
        empSlots: payload,
      };
    case GET_EMPANELMENT_DOCUMENTS:
      return {
        ...state,
        docDetails: payload,
      };
    case GET_EMPANELMENT_DOCUMENT_TYPES:
      return {
        ...state,
        docTypeDetails: payload,
      };
    default:
      return state;
  }
};

export { manufacturerEmpanelmentReducer };
